import { playAudio, seek } from './chunk-YHTQVMXH.mjs';
import { useRef, useState, useEffect, useCallback } from 'react';

var buildOrder = (length) => Array.from({ length }).map((_v, k) => k);
var SAudioPlayerLoopMode = /* @__PURE__ */ ((SAudioPlayerLoopMode2) => {
  SAudioPlayerLoopMode2["None"] = "none";
  SAudioPlayerLoopMode2["All"] = "all";
  SAudioPlayerLoopMode2["One"] = "one";
  return SAudioPlayerLoopMode2;
})(SAudioPlayerLoopMode || {});
var useSAudioPlayer = (inputs) => {
  const { audioList, index = 0, configs = {} } = inputs;
  const { shuffle = false, loopMode: loop = "all" /* All */ } = configs;
  const ref = useRef(null);
  const [indexes, setIndexes] = useState();
  const indexesRef = useRef(void 0);
  const [currentIndex, setCurrentIndex] = useState(index);
  const [isShuffled, setIsShuffled] = useState(shuffle);
  const [loopMode, setLoopMode] = useState(loop);
  const [isPlay, setPlay] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const total = audioList.length;
  const loopModes = ["all", "one", "none"];
  useEffect(() => {
    indexesRef.current = indexes;
  }, [indexes]);
  useEffect(() => {
    if (total) {
      setIndexes(buildOrder(total));
    }
  }, [total]);
  const onSelect = useCallback((flatIndex) => {
    const order = indexesRef.current;
    const slot2 = order ? order.indexOf(flatIndex) : flatIndex;
    setCurrentIndex(slot2 < 0 ? 0 : slot2);
  }, []);
  useEffect(() => {
    if (indexes && currentIndex > indexes.length - 1) {
      setCurrentIndex(0);
    }
  }, [indexes, currentIndex]);
  useEffect(() => {
    setIsShuffled(shuffle);
  }, [shuffle]);
  useEffect(() => {
    setLoopMode(loop);
  }, [loop]);
  const firstIndex = 0;
  const lastIndex = indexes ? (indexes == null ? void 0 : indexes.length) - 1 : 0;
  const isFirst = currentIndex === firstIndex;
  const isLast = currentIndex === lastIndex;
  const slot = indexes && currentIndex < indexes.length ? currentIndex : 0;
  const rawIndex = indexes ? indexes[slot] : 0;
  const i = rawIndex < audioList.length ? rawIndex : 0;
  const audioItem = audioList.length && indexes ? audioList[i] : null;
  const { src } = audioItem || {};
  const formatDuration = (value) => {
    const minute = Math.floor(value / 60);
    const secondLeft = Math.floor(value - minute * 60);
    return `${minute}:${secondLeft < 10 ? `0${secondLeft}` : secondLeft}`;
  };
  const onLoadedData = () => {
    if (!ref.current) {
      return;
    }
    setDuration(Math.ceil(ref.current.duration));
    if (isPlay) {
      ref.current.play();
    }
  };
  const onTimeUpdate = () => {
    if (!ref.current) {
      return;
    }
    setCurrentTime(ref.current.currentTime);
  };
  const onSeek = (position) => {
    if (!ref.current) {
      return;
    }
    setCurrentTime(ref.current.currentTime);
    seek(ref.current, position);
  };
  const onEnded = () => {
    if (loopMode === "one" /* One */) {
      if (!ref.current) {
        return;
      }
      setPlay(true);
      playAudio(ref.current);
      return;
    }
    if (isLast) {
      if (loopMode === "none" /* None */) {
        return setPlay(false);
      }
      setCurrentIndex(firstIndex);
    } else {
      setCurrentIndex(currentIndex + 1);
    }
    setPlay(true);
  };
  const onPlay = () => {
    if (!ref.current) {
      return;
    }
    setPlay(!isPlay);
    playAudio(ref.current);
  };
  const onPrev = () => {
    if (isFirst) {
      if (loopMode === "all" /* All */) {
        return setCurrentIndex(lastIndex);
      }
      return;
    }
    setCurrentIndex(currentIndex - 1);
  };
  const onNext = () => {
    if (isLast) {
      if (loopMode === "all" /* All */) {
        return setCurrentIndex(firstIndex);
      }
      return;
    }
    setCurrentIndex(currentIndex + 1);
  };
  const onShuffle = () => {
    if (!indexes) {
      return;
    }
    const currentFlat = indexes[currentIndex];
    const sortFunc = () => Math.random() > 0.5 ? 1 : -1;
    const nextOrder = isShuffled ? buildOrder(total) : [...indexes].sort(sortFunc);
    const nextSlot = nextOrder.indexOf(currentFlat);
    setIndexes(nextOrder);
    setCurrentIndex(nextSlot < 0 ? 0 : nextSlot);
    setIsShuffled(!isShuffled);
  };
  const onChangeLoopMode = () => {
    const index2 = loopModes.indexOf(loopMode);
    let newIndex;
    if (index2 === 2) {
      newIndex = 0;
    } else {
      newIndex = index2 + 1;
    }
    setLoopMode(loopModes[newIndex]);
  };
  const getAudioProps = () => {
    return {
      ref,
      src,
      onEnded,
      onLoadedData,
      onTimeUpdate
    };
  };
  const getSeekerProps = () => {
    return {
      max: duration,
      position: currentTime,
      setPosition: onSeek,
      formatDuration
    };
  };
  const getControlsProps = () => {
    return {
      onPlay,
      onPrev,
      onNext,
      onShuffle,
      onChangeLoopMode,
      onSelect
    };
  };
  return {
    getAudioProps,
    getSeekerProps,
    getControlsProps,
    playerState: {
      isPlay,
      isShuffled,
      loopMode,
      currentTime,
      audioItem,
      currentIndex: i
    }
  };
};
var useSAudioPlayer_default = useSAudioPlayer;

export { SAudioPlayerLoopMode, useSAudioPlayer_default };
//# sourceMappingURL=chunk-5LR3IRA3.mjs.map
//# sourceMappingURL=chunk-5LR3IRA3.mjs.map